angular.module("digitalLeasing.module").component("plafondProductData", {
    templateUrl: "ng/components/digitalLeasing/settingProductsRange/plafondProductData/plafondProductData.view.html",
    bindings: {
        model: "=", //prodottiConvenzione,
        pianoFinanziario: "=",
        onStructureChanges: "&",
        convenzionePlafond: "=",
        rangeIsOk: "&",
        rangeIsNotOk: "&",
        importo: "=",
        productList: "="
    },
    controllerAs: "plafondProductDataCtrl",
    controller: PlafondProductDataController
});

function PlafondProductDataController() {
    var self = this;

    self.$onInit = function () {

        self.supportModel = {
            newImporto: 0,
            initDurataMesiMin: self.pianoFinanziario.durataMesi,
            initDurataMesiMax: self.model.validations.durataMesi.massimo.valore,
            initAnticipoPercMin: self.model.validations.anticipoPerc.minimo.valore,
            initAnticipoPercMax: self.pianoFinanziario.anticipo.percentuale,
            initRiscattoPercMin: self.pianoFinanziario.riscatto.percentuale,
            initRiscattoPercMax: self.model.validations.riscattoPerc.massimo.valore,
            initSpreadNettoMin: self.pianoFinanziario.tassiCalcolati.spreadNetto,
            initSpreadNettoMax: self.model.validations.spreadNetto.massimo.valore,
            error: {
                importoAffidamento: false,
                durataMesi: false,
                canoniAnticipati: false,
                anticipoPerc: false,
                riscattoPerc: false,
                spreadNetto: false
            },
            durMesiMaxChanged: self.model.validations.durataMesi.massimo.valore,
            antPercMinChanged: self.model.validations.anticipoPerc.minimo.valore,
            risPercMaxChanged: self.model.validations.riscattoPerc.massimo.valore,
            sprPercMaxChanged: self.model.validations.spreadNetto.massimo.valore
        }

        self.productList.forEach(function (element) {
            if (self.model.cdProdotto === element.cdProdotto) {
                if (element.importoAffidamento) {
                    self.supportModel.newImporto = element.importoAffidamento;
                    element.importoAffidamento = element.importoAffidamento
                } else {
                    self.supportModel.newImporto = self.importo;
                    element.importoAffidamento = self.importo;
                }
            }
        });

        validateRange();
    };

    self.valitadionsChanged = function (property, value) {
        self.productList.forEach(function (element) {
            if (self.model.cdProdotto === element.cdProdotto) {
                switch (property) {
                    case "importoAffidamento":
                        if (value > self.importo) {
                            self.supportModel.error.importoAffidamento = true;
                        } else {
                            self.supportModel.error.importoAffidamento = false;
                            element.importoAffidamento = value;
                            self.supportModel.newImporto = value
                        }
                        break;
                    case "durataMesiMax":
                        if (value > self.supportModel.initDurataMesiMax ||
                            value < self.supportModel.initDurataMesiMin) {
                            self.supportModel.error.durataMesi = true;
                        } else {
                            self.supportModel.error.durataMesi = false;
                            element.validations.durataMesi.massimo.valore = value;
                        }
                        break;
                    case "anticipoPercMin":
                        if (value > self.supportModel.initAnticipoPercMax ||
                            value < self.supportModel.initAnticipoPercMin) {
                            self.supportModel.error.anticipoPerc = true;
                        } else {
                            self.supportModel.error.anticipoPerc = false;
                            element.validations.anticipoPerc.minimo.valore = value;
                        }
                        break;
                    case "riscattoPercMax":
                        if (value < self.supportModel.initRiscattoPercMin ||
                            value > self.supportModel.initRiscattoPercMax) {
                            self.supportModel.error.riscattoPerc = true;
                        } else {
                            self.supportModel.error.riscattoPerc = false;
                            element.validations.riscattoPerc.massimo.valore = value;
                        }
                        break;
                    case "spreadNettoMax":
                        if (value > 100 ||
                            value < self.supportModel.initSpreadNettoMin) {
                            self.supportModel.error.spreadNetto = true;
                        } else {
                            self.supportModel.error.spreadNetto = false;
                            element.validations.spreadNetto.massimo.valore = value;
                        }
                        break;
                    case "note":
                        self.convenzionePlafond[property] = value;
                        break;
                    default:
                        break;
                }
                validateRange();
            }
        });
    }

    self.onCheckboxChange = function (field) {
        field.ammetteKm0 = !field.ammetteKm0;
    };

    var validateRange = function () {
        for (i = 0; i < self.productList.length; i++) {
            if (!self.supportModel.error.importoAffidamento && !self.supportModel.error.durataMesi &&
                !self.supportModel.error.canoniAnticipati && !self.supportModel.error.anticipoPerc &&
                !self.supportModel.error.riscattoPerc && !self.supportModel.error.spreadNetto &&
                self.supportModel.initDurataMesiMin != null && self.supportModel.initDurataMesiMax != null &&
                self.productList[i].importoAffidamento &&
                self.productList[i].validations.durataMesi.minimo.valore != null &&
                self.productList[i].validations.durataMesi.massimo.valore != null &&
                self.productList[i].validations.anticipoPerc.minimo.valore != null &&
                self.productList[i].validations.anticipoPerc.massimo.valore != null &&
                self.productList[i].validations.riscattoPerc.minimo.valore != null &&
                self.productList[i].validations.riscattoPerc.massimo.valore != null &&
                self.productList[i].validations.spreadNetto.massimo.valore != null
            ) {
                self.rangeIsOk();
            } else {
                self.rangeIsNotOk();
                break;
            }
        }
    }
}